import React from "react";
import { NavLink, Navigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Navbar() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  const deconnexion = () => {
    localStorage.removeItem("tokenskanpay") && <Navigate to="/login" />;
  };

  return (
    <nav
      className="navbar navbar-expand-lg sticky-top blueSkanpay"
      id="enteteNavbar"
      style={{ color: "#fff", }}
    >
      <div className="container-fluid d-flex justify-content-between">
        <a
          href=""
          className="navbar-brand d-inline-block"
        >
          <img
            src="/images/LogoSKANnPay.png"
            width="100"
            height="100"
            alt="Logo SKANPAY"
            className="img img-fluid"
          />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon text-white">
            <i className="fa fa-bars"></i>
          </span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav nav nav-pills text-white ms-auto">
            <li className="nav-item">
              <NavLink
                className="nav-link link-white"
                activeclassname="nav-link link-white"
                aria-current="page"
                to="/dashboard"
              >
                <i className="fa fa-chart-bar"></i>
                {t('navbar.dashboard')}
              </NavLink>
            </li>
            {localStorage.getItem("role") === "ROLE_ADMIN" && (
              <li className="nav-item">
                <NavLink
                  className="nav-link link-white"
                  activeclassname="nav-link link-white"
                  to="/prestataires"
                >
                  <i className="fa fa-users"></i> {t('navbar.providers')}
                </NavLink>
              </li>
            )}
            {localStorage.getItem("role") === "ROLE_ADMIN_PRESTATAIRE" && (
              <li className="nav-item">
                <NavLink
                  className="nav-link link-white"
                  activeclassname="nav-link link-white"
                  to="/services"
                >
                  <i className="fa fa-users"></i> {t('navbar.services')}
                </NavLink>
              </li>
            )}

            <li className="nav-item">
              <NavLink
                className="nav-link link-black"
                activeclassname="nav-link link-white"
                to="/transactions"
              >
                {" "}
                <i className="fa fa-wallet"></i> {t('navbar.transactions')}
              </NavLink>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle link-white"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-money-bill"></i> {t('navbar.reversals')}
              </a>
              <ul className="dropdown-menu">
                <li>
                  <NavLink className="dropdown-item text-black" to="/reversements">
                    <i className="fas fa-money-bill"></i> {t('navbar.reversals')}
                  </NavLink>
                </li>
                {localStorage.getItem("role") === "ROLE_ADMIN" && (
                  <li>
                    <NavLink
                      className="dropdown-item text-black"
                      to="/reversementoperateur"
                    >
                      <i className="fas fa-money-bill"></i> {t('navbar.reversalsOps')}
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink className="dropdown-item text-black" to="/demandesreversements">
                    <i className="fa fa-hand-holding-usd"></i> {t('navbar.reversalRequests')}
                  </NavLink>
                </li>
              </ul>
            </li>
            {localStorage.getItem("role") !== "ROLE_UTILISATEUR_SERVICE" && (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle link-white"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fa fa-user"></i> {t('navbar.users')}
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink className="dropdown-item text-black" to="/utilisateurs">
                      <i className="fa fa-user"></i> {t('navbar.users')}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item text-black" to="/utilisateursapi">
                      <i className="fa fa-user"></i> {t('navbar.usersApi')}
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            <li className="nav-item">
              <NavLink
                className="nav-link link-white"
                activeclassname="nav-link link-white"
                to="/parametres"
              >
                <i className="fa fa-cog"></i> {t('navbar.settings')}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link link-white"
                activeclassname="nav-link link-white"
                to="/identifiants"
              >
                <i className="fas fa-key"></i> {t('navbar.credentials')}
              </NavLink>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle link-white"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-globe"></i> {i18n.language === 'fr' ? 'FR' : 'EN'}
              </a>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className={`dropdown-item ${i18n.language === 'fr' ? 'active' : ''}`}
                    onClick={() => changeLanguage('fr')}
                  >
                    Français
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${i18n.language === 'en' ? 'active' : ''}`}
                    onClick={() => changeLanguage('en')}
                  >
                    English
                  </button>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <button onClick={deconnexion} className="btn btn-dark ms-2">
                <Link to="/login">
                  <i className="fa fa-sign-out-alt"></i> {t('navbar.logout')}
                </Link>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
